import { actionTypes } from '../index';
import { ISelectedTariffParamsByAlias, ISelectedTariffParamsById } from '../initialState';

export const selectTariff = (params: ISelectedTariffParamsById | ISelectedTariffParamsByAlias) => ({
    type: actionTypes.SelectTariff,
    payload: {
        ...params,
    },
});
